const getters = {
    GET_ELECTRICITY_CATEGORIES: (state) => state.electricity_categories,
    GET_CABLE_CATEGORIES: (state) => state.cable_categories,
    GET_CABLE_PRODUCTS: (state) => state.cable_products,
    GET_EDUCATION_CATEGORIES: (state) => state.education_categories,
}

export default getters
